export default __webpack_public_path__ + "static/media/Copy of 79cm_general.27d1e3ae.mp4";